<div class="main">
  @if (hasError) {
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <ds-error-message [errorList]="errorList"></ds-error-message>
    </div>
  }

  <div class="row pad-top-20">
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <div></div>
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
  <ds-exit-flow-modal
    [exitFlowModalId]="exitFlowModalId"
    [isPartner]="isPartner$ | async"
    (exit)="navigateToOverview()"
    (cancelModal)="stayFromExitModal()"
    (notifyAgent)="sendToAgent(true)"
  ></ds-exit-flow-modal>
  <amfam-early-exit-modal
    [earlyExitFlowModalId]="earlyExitFlowModalId"
    [exitFlowConfimationText]="exitFlowConfimationText"
    [exitPrimaryButtonText]="exitPrimaryButtonText"
    [isPartner]="isPartner$ | async"
    (stay)="stayFromExitModal()"
    (leavePage)="navigateToOverview()"
  ></amfam-early-exit-modal>
  <ds-agent-selection-modal
    [agentSelectionModalId]="agentSelectionModalId"
    [agents]="agents$ | async"
    (confirmAgentSelection)="agentConfirmationFromModal($event)"
  ></ds-agent-selection-modal>
</div>
<!-- TODO: Add vehicle optimization -->
